<template>
  <!-- :permanent="$vuetify.breakpoint.mdAndUp"-->
  <v-navigation-drawer clipped app v-model="drawer" class="grey lighten-2" light>
    <v-list-item :to="'/event/' + $route.params.eventid+ '/screens'" exact>
      <v-list-item-icon>
        <v-icon>mdi-arrow-left</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title class="text-uppercase danimated fadeInDown">
          <span class="amberd--text">presentation</span>
          <span class="font-weight-light">editor</span>
        </v-list-item-title>
        <v-list-item-subtitle></v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-divider></v-divider>
    <v-list-group
      prepend-icon="mdi-file-presentation-box"
      color="grey darken-3"
      value="true"
      v-if="slide"
      style="position:sticky"
    >
      <template v-slot:activator>
        <v-list-item-title>Pages</v-list-item-title>
      </template>

      <draggable v-model="slides">
        <v-slide-y-transition group dense tag="v-list" shaped>
          <v-list-item
            dense
            v-for="(item, n) in slides"
            :key="item.uuid"
            link
            :to="'/event/' + $route.params.eventid+ '/screens/' + $route.params.slideid + '/' + item.uuid"
            exact
            :class="{
          lastitem: n === last
        }"
          >
            <v-list-item-content>
              <v-card style="border: 1px solid rgba(0,0,0,0.2" color="white ">
                <v-img src="@/assets/rainbow.jpg" height="100px"></v-img>
                <v-card-title class="caption black--text">{{ item.name }}</v-card-title>
              </v-card>
            </v-list-item-content>
          </v-list-item>
          <v-divider key="dev"></v-divider>
          <v-list-item link key="asdf">
            <v-list-item-icon>
              <v-icon>mdi-plus</v-icon>
            </v-list-item-icon>
            <v-list-item-action @click="addSlide = !addSlide">
              <v-list-item-action-text>add new slide</v-list-item-action-text>
            </v-list-item-action>
          </v-list-item>
        </v-slide-y-transition>
      </draggable>
    </v-list-group>
    <AddSlideDialog v-model="addSlide"></AddSlideDialog>
  </v-navigation-drawer>
</template>
<script>
import { mapState, mapActions } from "vuex";
import draggable from "vuedraggable";
import { sleep } from "@/utils";
import AddSlideDialog from "@/components/event/slides/AddSlideDialog";

export default {
  name: "default-drawer",
  components: {
    AddSlideDialog,
    draggable
  },
  data: () => ({
    eventId: null,
    timeout: 0,
    addSlide: false,
    items: [
      { title: "Event", icon: "mdi-view-dashboard", link: "", exact: true },
      {
        title: "Presentations",
        icon: "mdi-presentation",
        link: "/screens",
        exact: false
      }
    ],
    right: null
  }),
  methods: {
    ...mapActions("application", ["toggleLoading", "setError", "showDrawer"]),
    ...mapActions("slides", ["patch"])
  },
  async updated() {
    //console.log("scroll toi last item");
    //await sleep(() => this.$vuetify.goTo(".lastitem"), 500);
  },
  computed: {
    drawer: {
      get() {
        return this.$store.state.application.drawer;
      },
      set(val) {
        this.showDrawer(val);
      }
    },
    last() {
      return this.slide.slides.length - 1;
    },
    slide: {
      get() {
        const slideid = this.$route.params.slideid;
        return this.$store.state.slides.data[slideid];
      },
      async set(value) {
        try {
          let data = {
            id: this.$route.params.slideid,
            slides: value
          };

          await this.patch(data);
        } catch (E) {
          console.error(E);
        }
      }
    },
    slides: {
      get() {
        const slideid = this.$route.params.slideid;
        return this.$store.state.slides.data[slideid].slides;
      },
      async set(value) {
        try {
          console.log(value);
          let data = {
            id: this.$route.params.slideid,
            slides: value
          };

          await this.patch(data);
        } catch (E) {
          console.error(E);
        }
      }
    }
  }
};
</script>
